import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'

import { EnvironmentService } from '@surgetech-eu/core'
import { environment } from 'src/environments/environment'

const KEYE = 'eyedes'

export class KEYEPermissions {
    canActivate(roles: string[]): boolean {
        return roles.includes(KEYE)
    }
}

@Injectable()
export class KEYEGuard {
    constructor(
        private environment: EnvironmentService,
        private permissions: KEYEPermissions
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        return this.permissions.canActivate(this.environment.get().types || [])
    }

    static get isKEYE() {
        return (window['__env']?.types || environment.types)?.includes(KEYE)
    }
}
